import menuServices from "../api-service/menu-service";
import axios from "axios";
import Cookies from "js-cookie";
import { StateCreator } from "zustand";
import ProductModel from "../Models/PorductModel";
import BranchModel from "../Models/BranchModel";
import MenuModel from "../Models/MenuModel";
import { CategoryModel } from "../Models/CategoryModel";
import { SettingsModel, SettingsSocialMedia } from "../Models/SettingsModel";

export interface PrivacyPolicyData {
  ar?: {
    format: string;
    content: string;
  };
  en?: {
    format: string;
    content: string;
  };
}

export interface TermsOfServiceData {
  ar?: {
    format: string;
    content: string;
  };
  en?: {
    format: string;
    content: string;
  };
}

export interface MenuSlice {
  products: ProductModel[];
  product: ProductModel;
  branches: BranchModel[];
  branch: BranchModel;
  menus: MenuModel[];
  categories: CategoryModel[];
  Menuloading: boolean;
  categoryLoading: boolean;
  itemLoading: boolean;
  branchesLoading: boolean;
  loading: boolean;
  errorCode: string | number;
  searchProducts: ProductModel[];
  settings: SettingsModel;
  socialMedia: SettingsSocialMedia[];
  privacyPolicy: PrivacyPolicyData | null;
  termsOfService: TermsOfServiceData | null;
  privacyPolicyLoading: boolean;
  termsOfServiceLoading: boolean;
  fetchBranchesAction: () => Promise<any>;
  fetchMenusAction: (payload: any) => Promise<any>;
  fetchCategoriesAction: (payload: any) => Promise<any>;
  fetchProductsAction: (payload: any) => Promise<any>;
  fetchProductByAction: (payload: any) => Promise<any>;
  selectProductAction: (item: ProductModel) => void;
  fetchBrancheAction: (payload: any) => Promise<any>;
  fetchSearchProducts: (payload: any) => Promise<any>;
  fetchSettingsAction: () => Promise<any>;
  fetchPrivacyPolicyAction: () => Promise<any>;
  fetchTermsOfServiceAction: () => Promise<any>;
}
const getErrorCode = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    return String(error.response?.status ?? error.code ?? "Unknown Error");
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Unknown Error";
};
export const createMenuSlice: StateCreator<MenuSlice, []> = (set) => ({
  branches: [],
  branch: {} as BranchModel,
  menus: [],
  categories: [],
  products: [],
  product: {} as ProductModel,
  errorCode: "",
  Menuloading: false,
  categoryLoading: false,
  itemLoading: false,
  branchesLoading: false,
  loading: false,
  searchProducts: [],
  settings: {} as SettingsModel,
  socialMedia: [],
  privacyPolicy: null,
  termsOfService: null,
  privacyPolicyLoading: false,
  termsOfServiceLoading: false,
  fetchBranchesAction: async () => {
    set({
      branchesLoading: true,
    });
    try {
      const res = await menuServices.getBranches();
      console.log(res.data.data);
      set({
        branches: res.data.data,
        branchesLoading: false,
      });
      return res.data.data;
    } catch (error) {
      set({ branchesLoading: false, errorCode: getErrorCode(error) });
    }
  },
  /////////////////////////////////////////////////////////
  fetchMenusAction: async ({ branch_id }: any) => {
    set({ loading: true });
    try {
      // let paramsBranch = {};
      // let visit = 0;

      // if (!Cookies.get(`branch_${branch_id}`)) {
      //   const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
      //   Cookies.set(`branch_${branch_id}`, "1", {
      //     expires: oneHourFromNow,
      //   });
      //   visit = 1;
      //   paramsBranch = {
      //     branch_id: branch_id,
      //   };
      // } else {
      //   visit = 0;
      //   paramsBranch = { branch_id: branch_id, visit: visit };
      // }
      const res = await menuServices.getMenu({ branch_id });
      set({
        menus: res.data.data.sections,
        branch: res.data.data.branch,
        loading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        loading: false,
        errorCode: getErrorCode(error),
      });
    }
    return Promise.resolve(); // or return a promise from an API call
  },

  fetchCategoriesAction: async (params: any) => {
    set({ Menuloading: true });
    try {
      // let visit = 0;
      // if (!Cookies.get(`menu_${params.menu_id}`)) {
      //   const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
      //   Cookies.set(`menu_${params.menu_id}`, "1", {
      //     expires: oneHourFromNow,
      //   });
      //   visit = 1;
      // } else {
      //   visit = 0;
      // }
      const res = await menuServices.getCategory(params);
      set({
        categories: res.data.data,
        Menuloading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        Menuloading: false,
        errorCode: getErrorCode(error),
      });
    }
  },

  fetchProductsAction: async (params: any) => {
    set({ categoryLoading: true });
    try {
      let visit = 0;
      if (!Cookies.get(`category_${params.category_id}`)) {
        const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
        Cookies.set(`category_${params.category_id}`, "1", {
          expires: oneHourFromNow,
        });
        visit = 1;
      } else {
        visit = 0;
      }
      const res = await menuServices.getProduct({ ...params, visit: visit });
      set({
        products: res.data.data,
        categoryLoading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        categoryLoading: false,
        errorCode: getErrorCode(error),
      });
    }
  },


  fetchProductByAction: async ({ productId, branch_id }: any) => {
    set({ itemLoading: true });
    try {
      // let visit = 0;
      // if (!Cookies.get(`product_${productId}`)) {
      //   const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
      //   Cookies.set(`product_${productId}`, "1", {
      //     expires: oneHourFromNow,
      //   });
      //   visit = 1;
      // } else {
      //   visit = 0;
      // }
      const res = await menuServices.getProductById({
        productId: productId,
        branch_id: branch_id,
        // visit: visit,
      });
      set({
        product: res.data.data,
        itemLoading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        itemLoading: false,
        errorCode: getErrorCode(error),
      });
    }
  },

  selectProductAction: (item: ProductModel) => {
    set({ product: item });
  },
  ////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  ///////////////// products tags///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////


  fetchBrancheAction: async (payload: any) => {
    try {
      const res = await menuServices.getBranche(payload);
      set({
        branch: res.data.data.branch,
      });
      return res.data.data;
    } catch (error) {
      return getErrorCode(error);
    }
  },
  fetchSearchProducts: async (payload: any) => {
    try {
      const res = await menuServices.searchProduct(payload);
      set({
        searchProducts: res.data.data,
      });
      return res.data.data;
    } catch (error) {
      set({
        errorCode: getErrorCode(error),
      });
    }
  },
  fetchSettingsAction: async () => {
    try {
      const res = await menuServices.getSettings();
      // نحفظ الإعدادات في الـ store لتكون متاحة لباقي الواجهات
      set({
        settings: res.data.data,
        socialMedia: res.data.data.socialMedia,
      });
      return res.data.data;
    } catch (error) {
      const code = getErrorCode(error);
      set({ errorCode: code });
      return code;
    }
  },
  fetchPrivacyPolicyAction: async () => {
    set({ privacyPolicyLoading: true });
    try {
      const res = await menuServices.getPrivacyPolicy();
      set({
        privacyPolicy: res.data.data.privacy_policy,
        privacyPolicyLoading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        privacyPolicyLoading: false,
        errorCode: getErrorCode(error),
      });
    }
  },
  fetchTermsOfServiceAction: async () => {
    set({ termsOfServiceLoading: true });
    try {
      const res = await menuServices.getPrivacyPolicy();
      set({
        termsOfService: res.data.data.terms_of_service,
        termsOfServiceLoading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        termsOfServiceLoading: false,
        errorCode: getErrorCode(error),
      });
    }
  },
});
